import React, { Component } from 'react';

import { MessageBuilder } from '../TradingViewApi/MessageBuilder';
import { EmailConfig } from './EmailConfig';

export class TradingViewEmail extends Component {
    render() {
        return (
            <div>
                Your Apex Bot can receive alerts from{' '}
                <a
                    href="https://tradingview.go2cloud.org/aff_c?offer_id=2&aff_id=15553"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Trading View
                </a>
                , read the{' '}
                <a
                    href={
                        'https://apextrader.zendesk.com/hc/en-us/articles/360025062292-Signals-Trading-View-'
                    }
                    target="_blank"
                >
                    guide
                </a>{' '}
                to learn how.
                <EmailConfig />
                <MessageBuilder />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/SignalsView/TradingViewEmail/index.js